import {
    ButtonFixedFooterLayout,
    ButtonPrimary,
    Text3,
    skinVars,
    IbanField,
    useWindowSize,
    Text1,
} from '@telefonica/mistica';
import { formatMobileNumber } from '../../../../../utils/dataTransformation/unitsConversion';
import { useNavigate } from 'react-router-dom';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { updateCustomerAccounts } from '../../../../../services/CustomerService';
import { AxiosError } from 'axios';
import { setInfoError } from '../../../../../utils/dataTransformation/errorMesssages';
import { CustomerAccount } from '../../../../../models/Customer';
import './index.scss';
import HeaderProfile from '../../../../../components/HeaderProfile';

export const UpdateBankAccount: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { trackingScreenView } = new TrackingEvents();
    const [rawValue, setRawValue] = useState<string>('');
    const [valueIban, setValueIban] = useState<string>('');
    const size = useWindowSize();
    sessionStorage.removeItem('pathOrigin');

    const storage = localStorage.getItem('storage')!;
    let account: CustomerAccount = JSON.parse(storage).account!;

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    const handleNavigate = (url: string, description: string, err?: any) => {
        localStorage.setItem('storage', JSON.stringify({ state: description, err: err }));
        navigate(url, { state: description });
    };

    const handleChange = (e: React.ChangeEvent<any>) => setRawValue(e.target.value);
    const handleChangeValue = (v: any) => setValueIban(v);

    const postBankAccountUpdate = () => {
        const data = { accountId: account?.id!, iban: valueIban };
        updateCustomerAccounts(data)
            .then(() => {
                handleNavigate('/update-bank-account/feedback', 'SUCCESS');
            })
            .catch((error: AxiosError) => {
                const { id, httpCode } = setInfoError(error);

                if (httpCode !== 401 && id !== 'X401502') {
                    handleNavigate('/update-bank-account/feedback', 'ERROR', error);
                }
            });
    };

    return (
        <div className='updatebBankAccount-page'>
            <HeaderProfile
                title='supportContentRowChangeBankAccount'
                breadcrumbs={[
                    { title: t('profileTitle'), url: '/profile' },
                    { title: t('personalDataTitle2'), url: '/profile/personal-data' },
                ]}
            />
            {size.width >= 768 ? (
                <div className='updatebBankAccount-page__content'>
                    {size.width >= 1024 && (
                        <div className='updatebBankAccount-page__content-title'>
                            <Text1 regular color={skinVars.colors.textSecondary}>
                                {t('bankAccountTitle')}
                            </Text1>
                        </div>
                    )}

                    <div className='updatebBankAccount-page__content-subtitle'>
                        <Text3 regular color={skinVars.colors.textPrimary}>
                            {t('profileChangeBankAccountText2')}
                        </Text3>
                    </div>
                    <div className='updatebBankAccount-page__content__selectedLines'>
                        <Text3 medium color={skinVars.colors.textPrimary}>
                            {t('last4charactersText')}
                            {account?.number?.substring(account?.number?.length - 4)!}
                        </Text3>
                        {account?.productNumbers?.map((num: string, index: number) => {
                            return (
                                <Text3 key={index} regular color={skinVars.colors.textSecondary}>
                                    {formatMobileNumber(num)}
                                </Text3>
                            );
                        })}
                    </div>
                    <div className='updatebBankAccount-paget__content__iban'>
                        <div className='updatebBankAccount-page__content__iban__text'>
                            <Text3 regular color={skinVars.colors.textPrimary}>
                                {t('profileChangeBankAccountText3')}
                            </Text3>
                        </div>
                        <IbanField
                            name='bankAccount'
                            label={t('profileChangeBankAccountLabel')}
                            onChange={handleChange}
                            onChangeValue={handleChangeValue}
                            value={valueIban}
                            helperText={t('profileChangeBankAccountHelperText')}
                        />
                    </div>
                    <div className='updatebBankAccount-page__content-buttonPrimary'>
                        <ButtonPrimary
                            disabled={valueIban.length < 24 || valueIban.length > 24}
                            onPress={() => {
                                postBankAccountUpdate();
                            }}
                        >
                            {t('save')}
                        </ButtonPrimary>
                    </div>
                </div>
            ) : (
                <ButtonFixedFooterLayout
                    button={
                        <ButtonPrimary
                            disabled={valueIban.length < 24 || valueIban.length > 24}
                            onPress={() => {
                                postBankAccountUpdate();
                            }}
                        >
                            {t('save')}
                        </ButtonPrimary>
                    }
                >
                    <div className='updatebBankAccount-page__content'>
                        <div className='updatebBankAccount-page__content__text1'>
                            <Text3 regular color={skinVars.colors.textPrimary}>
                                {t('profileChangeBankAccountText2')}
                            </Text3>
                        </div>
                        <div className='updatebBankAccount-page__content__selectedLines'>
                            <Text3 medium color={skinVars.colors.textPrimary}>
                                {t('last4charactersText')}
                                {account?.number?.substring(account?.number?.length - 4)!}
                            </Text3>
                            {account?.productNumbers?.map((num: string, index: number) => {
                                return (
                                    <Text3 key={index} regular color={skinVars.colors.textSecondary}>
                                        {formatMobileNumber(num)}
                                    </Text3>
                                );
                            })}
                        </div>

                        <div className='updatebBankAccount-page__content__iban'>
                            <div className='updatebBankAccount-page__content__iban__text'>
                                <Text3 regular color={skinVars.colors.textPrimary}>
                                    {t('profileChangeBankAccountText3')}
                                </Text3>
                            </div>
                            <IbanField
                                name='bankAccount'
                                label={t('profileChangeBankAccountLabel')}
                                onChange={handleChange}
                                onChangeValue={handleChangeValue}
                                value={valueIban}
                                helperText={t('profileChangeBankAccountHelperText')}
                            />
                        </div>
                    </div>
                </ButtonFixedFooterLayout>
            )}
        </div>
    );
};

export default UpdateBankAccount;
